import React from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

const MultiSelect = ({...props}) => {
  return(
    <Select
    multi={true}
    value={props.selectedChannelAdministrators}
    onChange={ (input) => props.input.onChange(input) }
    options={props.options}
    {...props}
    />
  )
}

export default MultiSelect;




// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/Forms/components/MultiSelect.js